import React, { useState, useRef, useEffect } from "react";
import {
  FormControl,
  FormControlLabel,
  Typography,
  TextField,
  RadioGroup,
  Radio,
  Checkbox,
  Button,
  Box,
  FormHelperText,
  Autocomplete,
  Select,
  MenuItem,
  InputLabel,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
// import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import localizedFormat from "dayjs/plugin/localizedFormat";
import dayjs from "dayjs";
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import * as yup from "yup";
import { useSelector, useDispatch } from "react-redux";
// import { fetchSuppliersByCompanyId } from '../../../../redux/orderSlice';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  getCompanyType,
  getIntegratedPlayerList,
} from "../../../../redux/authSlice";
import {
  fetchParentCompanyDetails,
  updateCompanyAPI,
  updatePendingCompany,
  updateUserfromPendingCompany,
} from "../../../../redux/adminSlice";
import LinkedParentCompanyModal from "../LinkedParentCompanyModal";
import linkIcon from "../../../../assets/images/link.svg";

dayjs.extend(localizedFormat);
const formattedDate = dayjs().format("LL");

// Create a new object with the shape of our input initial state variable.const

export const ADD_EDIT_COMPANY_VALIDATION = yup.object().shape({
  companyName: yup.string().required("Company Name cannot be empty."),
  url: yup.string().required("Company URL is required."),
  companyTypeId: yup.string().required("Company Tyoe is required."),

  // export: yup.boolean().oneOf([true], 'Export'),
  description: yup.string().required("Company Description is required."),
});
const EditPendingUsers = ({
  onSubmit,
  actionType,
  currentStep,
  className,
  step,
  linkedOrderList,
  totalRecordsLink,
  handleNextStep,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { loading } = useSelector((state) => state.admin);
  const { orderId } = useParams();
  const linkedCompanyList = useSelector(
    (state) => state.admin.parentCompanyList || []
  );
  const companyTypeOptions = useSelector(
    (state) => state.auth.companyType || []
  );
  const IPlistOptions = useSelector((state) => state.auth.checkIPlist || []);
  const [companyType, setCompanyType] = useState("");
  const [checkedItems, setCheckedItems] = useState({});
  const [isExport, setIsExport] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  // const defaultValues = {
  //     companyName: '',
  //     companyTypeId: '',
  //     url: '',
  //     description: '',
  //     isExport: ''
  // }

  const {
    createdDate,
    modifiedDate,
    rejectedReason,
    rejectedDate,
    isActive,
    // companyBuName,
    compabyLogo,
    user,
    firstName,
    lastName,
    prefix,
    ...rest
  } = location.state?.pendingCompanyDetails || {};
  delete rest.createdDate;
  delete rest.modifiedDate;
  delete rest.rejectedReason;
  delete rest.rejectedDate;
  delete rest.isActive;
  delete rest.companyLogo;
  delete rest.user;
  delete rest.firstName;
  delete rest.lastName;
  delete rest.prefix;
  const initialValues = location.state?.pendingCompanyDetails || {};

  // console.log(">>:: ADD COMPANY ::>>>", initialValues, actionType)
  useEffect(() => {
    dispatch(getCompanyType());
  }, [dispatch]);
  // console.log('company type list values', companyTypeOptions);

  useEffect(() => {
    // Simulate fetching data from an API
    dispatch(getIntegratedPlayerList());
  }, [dispatch]);

  useEffect(() => {
    const queryParams = {
      companyKeyId: initialValues.companyId,
      pageNumber: 1,
      pageSize: 12,
      searchText: "",
    };
    dispatch(fetchParentCompanyDetails(queryParams));
  }, [dispatch]);

  const handleChangeIPlist = (event) => {
    const { name, checked } = event.target;
    setCheckedItems((prev) => ({ ...prev, [name]: checked }));
  };
  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  const handleExportChange = (event) => {
    setIsExport(event.target.checked);
    setFieldValue("isExport", checked);
  };
  const handleEditCompanyChange = (formattedValues) => {
    console.log("handleEditCompanyChange", formattedValues);
    const companyData = formattedValues;
    dispatch(updateUserfromPendingCompany(companyData))
      .then((response) => {
        const companyDetails = response.payload;

        if (companyDetails.success === true) {
          navigate(-1);
        }
      })
      .catch((error) => {
        console.error("Fetching user details error:", error);
      });
  };
  // console.log('Company Id is ', rest,  initialValues, 'linkedCompanyList', linkedCompanyList)
  return (
    <>
      <div className={className}>
        <div className="main-content">
          <nav aria-label="breadcrumb" className="bread-box">
            <div>
              <h1 className="fprimary">
                {location.state?.actionType === "edit"
                  ? "Edit company"
                  : "Add company"}
              </h1>
              <h5 className="">
                {location.state?.actionType === "edit" ? "Edit" : "Add"} Company
                details to create a new company
              </h5>
            </div>
            <div>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {location.state?.actionType === "edit" ? "Edit" : "Add"}
                  Company
                </li>
              </ol>
            </div>
          </nav>
          <div className="card mt-3 bg-stage">
            {/* {location.state?.actionType === "edit" && (
                            <div className="ps-4 pe-4">
                                <h1 className="fprimary">Company Details</h1>
                            </div>
                        )} */}
            <Formik
              // initialValues={editValue || defaultValues}
              initialValues={{
                userId: initialValues?.user?.userId || "",
                firstName: initialValues?.user?.firstName || "",
                lastName: initialValues?.user?.lastName || "",
                prefix: initialValues?.user?.prefix || "",
                // ...rest,
              }}
              enableReinitialize={true}
              // validationSchema={ADD_EDIT_COMPANY_VALIDATION}
              onSubmit={(values, { setSubmitting }) => {
                const companyRolesIds = Object.keys(checkedItems)
                  .filter((key) => checkedItems[key])
                  .map((key) => {
                    const foundItem = IPlistOptions.find(
                      (item) => item.company_rolename === key
                    );
                    return foundItem ? foundItem.company_role_id : null;
                  })
                  .filter((id) => id !== null);

                const formattedValues = {
                //   companyRolesIds,
                  firstName,
                  lastName,
                  prefix,
                  ...values,
                };
                console.log("AddEditCompany Submit:", formattedValues);
                if (location.state?.actionType === "edit") {
                  handleEditCompanyChange({ ...formattedValues });
                }
                // onSubmit(formattedValues);
                setSubmitting(false);
              }}
            >
              {({
                values,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                touched,
              }) => (
                // <form onSubmit={handleSubmit}>
                <Form onSubmit={handleSubmit}>
                  <div className="card-body m-3">
                    <div className="col-md-2 cs-form mb-2">
                      <FormControl className="md-input">
                        <InputLabel id="unit-label">Prefix *</InputLabel>
                        <Select
                          labelId="unit-label"
                          name="prefix"
                          value={values.prefix}
                          label="Prefix"
                          onChange={handleChange}
                          error={errors.prefix}
                          helperText={errors.prefix}
                        >
                          <MenuItem value="1">Ms</MenuItem>
                          <MenuItem value="2">Mr</MenuItem>
                          <MenuItem value="3">Mrs</MenuItem>
                          {/* ... other units */}
                        </Select>

                        <FormHelperText>
                          {touched.uPrefix && errors.uPrefix}
                        </FormHelperText>
                      </FormControl>
                    </div>
                    <div className="col-md-5 cs-form mb-3">
                      <TextField
                        // label={t("companyProfile.companyName")}
                        label={"First Name"}
                        className="md-input"
                        name="firstName"
                        value={values.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.firstName}
                        helperText={errors.firstName}
                      />
                    </div>
                    <div className="col-md-5 cs-form mb-3">
                      <TextField
                        // label={t("companyProfile.companyName")}
                        label={"Last Name"}
                        className="md-input"
                        name="lastName"
                        value={values.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.lastName}
                        helperText={errors.lastName}
                      />
                    </div>

                    <div className="d-flex justify-content-between">
                      <button
                        type="button"
                        className="btn btn-light grey-btn lg-btn"
                        onClick={() => navigate(-1)}
                      >
                        {t("createOrder.back")}
                      </button>
                      {/* <Button color="primary" variant="contained" type="submit" disabled={isSubmitting}>
                                Create Order
                                
                            </Button> */}
                      <button
                        className="btn btn-primary greeen-btn lg-btn"
                        type="submit"
                        variant="contained"
                        // onClick={updateFormData} // Use onClick to trigger form submission
                        // disabled={ isValid || isSubmitting }
                      >
                        {/* Create Order */}
                        {/* {loading ? "Submitting..." : "Add"} */}
                        {location.state?.actionType !== "edit"
                          ? "Next"
                          : "Submit"}
                        {/*  t('createOrder.createOrderbtn') */}
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};
export default EditPendingUsers;
